import React from "react";

import {
  asyncMessengerOpen,
  fetchChatUserHash,
} from "@origin-digital/event-dispatcher";
import { Button } from "@origin-digital/ods-core";
import { IconLiveChat } from "@origin-digital/ods-icons";
import { LIVE_CHAT_LABEL } from "./LiveChatSupport";

interface LiveChatButtonProps {
  label?: string;
}

export const LiveChatButton = ({ label }: LiveChatButtonProps) => {
  const getLabel = label || LIVE_CHAT_LABEL;

  const onClick = async () => {
    try {
      const result = await fetchChatUserHash({});
      const userHash = result?.userHash || "";
      asyncMessengerOpen({ userHash });
    } catch (error) {
      console.error("Failed to fetch chat user hash:", error);
      // Fallback to empty string if fetch fails
      asyncMessengerOpen({ userHash: "" });
    }
  };

  return (
    <Button
      icon={<IconLiveChat size="small" color="iconDark" />}
      onClick={onClick}
    >
      {getLabel}
    </Button>
  );
};
